import script from "./UserListRow.vue?vue&type=script&setup=true&lang=js"
export * from "./UserListRow.vue?vue&type=script&setup=true&lang=js"

import "./UserListRow.vue?vue&type=style&index=0&id=6b3ba469&scoped=true&lang=scss"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b3ba469"]])

export default __exports__